export { default } from './RatingScale';
